/* eslint-disable import/prefer-default-export */
export const ThemeType = {
    Light: 'light',
    Dark: 'dark',
};
